<script setup lang="ts">
import TBase from './TBase.vue';
import type { TypographyBaseProps } from './types';

defineOptions({
  name: 'CustomH2',
});

const props = withDefaults(defineProps<TypographyBaseProps>(), {
  fontFamily: 'BMWGroupTNC',
  size: 40,
  color: 'inherit',
  weight: 700,
  onClick: undefined,
});
</script>

<template>
  <TBase v-bind="props">
    <slot />
  </TBase>
</template>
